import { module } from 'angular';
import inputGeoComponent from './input-geo.component';

export default module('app')
	.component('inputGeo', inputGeoComponent)
	.name;
